import { inject, injectable } from "@launchtray/tsyringe-async";
import { IPaymentsProvider } from "./IPaymentsProvider";
import { IApplePayApi } from "./IApplePayApi";
import { PurchaseItemData } from "./PurchaseItemData";
import { PaymentStatus } from "./PaymentStatus";
import { PromiseCompletionSource } from "../../shared/async/PromiseCompletionSource";
import { ILogger } from "../logger/ILogger";

@injectable()
export class ApplePayProvider implements IPaymentsProvider {
    private readonly applePayApi: IApplePayApi;
    private readonly logger: ILogger;

    public constructor(
        @inject("IApplePayApi") applePayApi: IApplePayApi,
        @inject("ILogger") logger: ILogger
    ) {
        this.applePayApi = applePayApi;
        this.logger = logger;
    }

    public async initiatePurchase(purchaseItem: PurchaseItemData): Promise<PaymentStatus> {
        const paymentStatus = await this.startPaymentSession(purchaseItem);
        return paymentStatus;
    }

    private async startPaymentSession(purchaseItem: PurchaseItemData): Promise<PaymentStatus> {
        const paymentSessionCS = new PromiseCompletionSource<PaymentStatus>();
        try {
            this.applePayApi.startPaymentSession(purchaseItem, paymentSessionCS);
            const paymentStatus = await paymentSessionCS.result;
            this.logger.info(`Payment complete with status: ${paymentStatus}`);
            return paymentStatus;
        } catch (error: unknown) {
            this.logger.error(error)
            return PaymentStatus.FAILURE;
        }
    }
}
